import { render } from "./Hatchback.vue?vue&type=template&id=5a374ee6"
import script from "./Hatchback.vue?vue&type=script&lang=js"
export * from "./Hatchback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/Icons/Hatchback.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a374ee6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a374ee6', __exports__)) {
    api.reload('5a374ee6', __exports__)
  }
  
  module.hot.accept("./Hatchback.vue?vue&type=template&id=5a374ee6", () => {
    api.rerender('5a374ee6', render)
  })

}


export default __exports__